import { Label, Select, TextInput } from "flowbite-react";
import { useEffect, useMemo } from "react";

const ExerciseInput = ({
  handleChange,
  exerciseTypeId,
  commonData,
  selected,
}: any) => {
  const filteredExercises = useMemo(() => {
    if (commonData && exerciseTypeId) {
      return commonData.exercises.filter(
        (e: any) => e.exerciseType.id === exerciseTypeId,
      );
    }
    return [];
  }, [commonData, exerciseTypeId]);

  useEffect(() => {
    if (commonData && exerciseTypeId) {
      const filtered = commonData.exercises.filter(
        (e: any) => e.exerciseType.id === exerciseTypeId,
      );
      if (!filtered.some((e: any) => e.id === selected)) {
        // filtered and selected doesn't match, select default position 0
        handleChange({
          target: {
            name: "exercise",
            value: filtered[0].id,
          },
        });
      }
    }
  }, [exerciseTypeId, selected, handleChange, commonData]);
  if (exerciseTypeId) {
    return (
      <div>
        <Label>Exercise</Label>
        <div className="mt-1">
          <Select onChange={handleChange} name="exercise">
            <option selected disabled>
              Choose
            </option>
            {filteredExercises.map((x: any) => {
              return (
                <option key={x.id} value={x.id} selected={x.id === selected}>
                  {x.name}
                </option>
              );
            })}
          </Select>
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <Label>Exercise</Label>
        <div className="mt-1">
          <TextInput disabled placeholder="Select exercise type" type="text" />
        </div>
      </div>
    );
  }
};

export default ExerciseInput;
